import { NavbarItem } from "components/UI/molecules";

export const renderMenuItem = (isLoggedIn, item) => {
  if (item.divider) return <hr key={item.logId} data-testid={item.logId} />;

  const isLoggedInItem = isLoggedIn && item.loggedIn;
  const isLoggedOutItem = !isLoggedIn && item.loggedOut;
  const isBoth = !item.loggedIn && !item.loggedOut;

  if (isLoggedInItem || isLoggedOutItem || isBoth)
    return (
      <NavbarItem
        label={item.label}
        path={item.path}
        logId={item.logId}
        isExternalLink={item.isExternalLink}
        key={item.logId}
        onClick={item.onClick}
        isOverlay={true}
      />
    );
};
